/**
 * Query params for `GET /brands/list` (BOS-81). Mirrors the bos-api
 * `BrandsListQuery`: 1-based `page`, `pageSize` (capped at
 * {@link BRAND_LIST_MAX_PAGE_SIZE} server-side), and an optional
 * case-insensitive `search` over the brand name. The API orders results by
 * name; there is no sort parameter.
 */
export type BrandListQuery = {
    page: number;
    pageSize: number;
    search?: string;
};

/** Largest `pageSize` the bos-api honours (`BrandsListQuery.MaxPageSize`). */
export const BRAND_LIST_MAX_PAGE_SIZE = 200;

/**
 * Query for consumers that need the whole brand set (pickers, label lookups,
 * import name-matching) rather than a specific page. Module-level so the key
 * stays referentially stable across callers.
 */
export const ALL_BRANDS_QUERY: BrandListQuery = {
    page: 1,
    pageSize: BRAND_LIST_MAX_PAGE_SIZE,
};
